import { CommonModule } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import { Color } from '../common/types';

export type BadgeVariant = 'outline' | 'dash' | 'soft' | 'ghost';
export type BadgeSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

@Component({
  selector: 'app-badge',
  template: `
    <div
      class="badge min-w-max"
      [ngClass]="[currentColor(), currentVariant(), currentSize()]"
    >
      <ng-content />
    </div>
  `,
  imports: [CommonModule],
})
export class Badge {
  color = input<Color>('primary');
  variant = input<BadgeVariant>('soft');
  size = input<BadgeSize>('md');

  currentColor = computed(() => {
    switch (this.color()) {
      case 'primary':
        return 'badge-primary';
      case 'secondary':
        return 'badge-secondary';
      case 'accent':
        return 'badge-accent';
      case 'info':
        return 'badge-info';
      case 'success':
        return 'badge-success';
      case 'warning':
        return 'badge-warning';
      case 'error':
        return 'badge-error';
      case 'neutral':
        return 'badge-neutral';
      default:
        return 'badge-primary';
    }
  });

  currentVariant = computed(() => {
    switch (this.variant()) {
      case 'outline':
        return 'badge-outline';
      case 'dash':
        return 'badge-dash';
      case 'soft':
        return 'badge-soft';
      case 'ghost':
        return 'badge-ghost';
      default:
        return 'badge-soft';
    }
  });

  currentSize = computed(() => {
    switch (this.size()) {
      case 'xs':
        return 'badge-xs';
      case 'sm':
        return 'badge-sm';
      case 'md':
        return 'badge-md';
      case 'lg':
        return 'badge-lg';
      case 'xl':
        return 'badge-xl';
      default:
        return 'badge-md';
    }
  });
}
